module.exports = __webpack_public_path__ + "static/img/set_receiving_icon.3fc7621e.png";